import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { SidebarGroup, SidebarGroupContent } from '@/components/ui/sidebar';
    import { type NavItem } from '@/types';
    import NavMenu from '@/components/NavMenu.vue';

    interface Props {
        items: NavItem[];
        class?: string;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'NavFooter',
  props: {
    items: {},
    class: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SidebarGroup), {
    class: _normalizeClass(`group-data-[collapsible=icon]:p-0 ${_ctx.$props.class || ''}`)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(SidebarGroupContent), null, {
        default: _withCtx(() => [
          _createVNode(NavMenu, { items: _ctx.items }, null, 8, ["items"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})